import type { SYSAction } from "../../../../../_ovlclient/src"
import { Data } from "../../../../../_ovlclient/src/dataapi"
import type { SYSFormState } from "../../../../../_ovlclient/src/library/forms/fieldapi"
import { FormReset } from "../../../../../_ovlclient/src/library/forms/formapi"

import {
  ProcessEnd,
  ProcessStart,
} from "../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { SnackAdd } from "../../../../../_ovlclient/src/library/snackapi"
import { T } from "../../../../../_ovlclient/src/textapi"
import { ValidationsAdd } from "../../../../src/library/forms/validatorsapi"

const SaveSettings: SYSAction<{
  formState: SYSFormState
  mode: "PwReset"
}> = async ({ formState, mode }, { global }) => {
  let state = global.getState()

  let pw = formState.fields["pw"].value
  let pw1 = formState.fields["pw1"].value
  let res
  ProcessStart("SYSUserSettingsSave", {
    lock: { formState },
    snack: { type: "none" },
  })
  try {
    res = await Data("users/changepw", {
      password: pw,
      passwordNew: pw1,
      language: state.ovl.session.Language,
      mode,
    })
    if (res.TOTPCanceled) {
      return
    }
    FormReset(formState)
    if (mode === "PwReset") {
      location.reload()
      return
    }
    SnackAdd(T("SYSLoginPasswordChangedSuccess"), "Success")
  } catch (res) {
    // most probably the password is wrong
    if (res.type && res.type === "InvalidCredentials") {
      ValidationsAdd(
        formState.fields["pw"],
        "SYSLoginValidationInvalidPassword",
        "Validate",
        {
          setFocus: true,
        }
      )
    }
    return
  } finally {
    ProcessEnd("SYSUserSettingsSave")
  }
}
export let actions = { SaveSettings }
